import { SubstructureStub } from "./SubstructureStub";
export const SubstructureDefault = SubstructureStub;
// import { SubstructureEmbedded } from "./SubstructureEmbedded";
// export const SubstructureDefault = SubstructureEmbedded;
//# sourceMappingURL=SubstructureDefault.js.map